import {Component, Injectable, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';
import {NgbTimeAdapter, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

const pad = (i: number): string => i < 10 ? `0${i}` : `${i}`;

/**
 * Example of a String Time adapter
 */
@Injectable()
export class NgbTimeStringAdapter extends NgbTimeAdapter<string> {

	fromModel(value: string| null): NgbTimeStruct | null {
		if (!value) {
			return null;
		}
		const split = value.split(':');
		return {
			hour: parseInt(split[0], 10),
			minute: parseInt(split[1], 10),
			second: parseInt(split[2], 10)
		};
	}

	toModel(time: NgbTimeStruct | null): string | null {
		return time != null ? `${pad(time.hour)}:${pad(time.minute)}` : null;
	}
}

@Component({
	selector: 'form-timepicker',
	templateUrl: './timepicker.component.html',
	styleUrls: ['./timepicker.component.scss'],
	encapsulation:ViewEncapsulation.None,
	providers: [{provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter}]
})
export class TimepickerComponent implements OnInit {

	@Input()
	control: UntypedFormControl;

	@Input()
	id: string = this.dynamicIdService.getId('timepicker');

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.inline;

	@Input()
	spellcheck: boolean;

	@Input() set isDeprecated(deprecated: boolean) {
		this.deprecated = deprecated;
	}

	ControlTemplate = ControlTemplate;
	deprecated: boolean;

	time: string;

	constructor(private dynamicIdService: DynamicIdService) {
	}

	ngOnInit(): void {
		if (!this.control) throw new Error('Control is required');

		this.time = this.control.value;
	}

	updateModel() {
		this.control.setValue(this.time);
		this.markUserChanged();
	}

	private markUserChanged() {
		this.control.markAsDirty();
		this.control.markAsTouched();
	}
}
